import { GooglePlacesClient } from "../../backendApi/google-places.generated";
const googlePlacesClient = new GooglePlacesClient(window.location.origin);
export const fetchGooglePlacesOpeningHours = async (id)=>{
    var openingHours = await googlePlacesClient.searchOpeningHours(id);
    return openingHours;
};
